module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('headerpage', {
    attrs: {
      "status": 4
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "degro22und"
  }, [_c('div', {
    staticClass: "adaptation",
    staticStyle: {
      "background-color": "#f6f8f7"
    }
  }, [_c('div', {
    staticClass: "hetext"
  }, [_vm._v("首页>本地政策>详情")]), _vm._v(" "), (_vm.detail) ? _c('div', {
    staticClass: "box"
  }, [_c('div', [_c('div', {
    staticClass: "box_tt"
  }, [_vm._v(_vm._s(_vm.detail.subtitle))]), _vm._v(" "), _c('div', {
    staticClass: "box_tt1"
  }, [_c('span', {
    staticStyle: {
      "color": "#9b9b9b"
    }
  }, [_vm._v("发布时间：")]), _vm._v(_vm._s(_vm.detail.created_at))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "25px"
    }
  }, [_c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "box1_ttt"
  }, [_vm._v("支持领域")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.territory)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "box1_ttt"
  }, [_vm._v("依据文件")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.according)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "box1_ttt"
  }, [_vm._v("最新动态")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "box1_ttt"
  }, [_vm._v("申报条件")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.declare_condition)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "box1_ttt"
  }, [_vm._v("支持力度")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detail.level,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "index",
      "align": "center",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "level",
      "align": "center",
      "label": "支持等级"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "factor",
      "align": "center",
      "label": "资助条件"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "money",
      "align": "center",
      "label": "资助金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "参考文件",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "cpoint",
          staticStyle: {
            "color": "#0081ff"
          },
          attrs: {
            "data-url": scope.row.href
          },
          on: {
            "click": function($event) {
              return _vm.toout(scope.row.href)
            }
          }
        }, [_vm._v(_vm._s(scope.row.file))])]
      }
    }], null, false, 1920358502)
  })], 1)], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "25px"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f176fb0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/policydetail.vue
// module id = 898
// module chunks = 1